export default __webpack_public_path__ + "static/media/Stamina of the Wolf.c87f15dd.jpg";